import React, { useEffect, useState } from 'react'
import {
  Form,
  Input,
  Button,
  Row,
  Col,
  Select,
  Upload,
  DatePicker,
  message,
  Divider,
  Space,
  Radio,
  Table,
  Spin,
  Modal,
} from 'antd'
import {
  DeleteOutlined,
  EditOutlined,
  EyeOutlined,
  PlusOutlined,
  UploadOutlined,
} from '@ant-design/icons'
import AdminHeader from '../CommonComponents/AdminHeader'
import AdminFooter from '../CommonComponents/AdminFooter'
import './StudentAdmissionForm.css'
import { toast } from 'react-toastify'
import {
  DeleteChildrenHomeVisitData,
  GetChildrenHomeVisitData,
  getChildrenList,
  IMG_URL,
  saveChildrenHomeVisitData,
  updateChildrenHomeVisitData,
} from '../APIComponents/AdminApi'
import dayjs from 'dayjs'
import axiosInstance from '../../Utils/axiosInstance'

const { Option } = Select
const { TextArea } = Input

const ChildrenHomeVisitForm = () => {
  //===============================================
  const loginType = sessionStorage.getItem('loginType') // 'ADMIN' or 'USER'
  const menuData = JSON.parse(sessionStorage.getItem('menus')) || []

  const getPagePermission = () => {
    if (loginType === 'ADMIN') {
      return {
        is_new: 1,
        is_edit: 1,
        is_view: 1,
        is_delete: 1,
      }
    }

    for (const menu of menuData) {
      const page = menu.pages?.find(
        (p) => p.page_name === "Children's home visit (S I R)",
      )
      if (page) return page
    }

    return {
      is_new: 0,
      is_edit: 0,
      is_view: 0,
      is_delete: 0,
    }
  }

  const pagePermission = getPagePermission()
  const showActionColumn =
    loginType === 'ADMIN' ||
    pagePermission.is_edit == 1 ||
    pagePermission.is_view == 1 ||
    pagePermission.is_delete == 1
  //============================================

  const [form] = Form.useForm()
  const [childrenList, setChildrenList] = useState([])
  const [tableData, setTableData] = useState([])
  const [loading, setLoading] = useState(false)

  const [showForm, setShowForm] = useState(false)
  const [isEditMode, setIsEditMode] = useState(false)
  const [editingId, setEditingId] = useState(null)
  const [searchText, setSearchText] = useState('')
  const [currentPage, setCurrentPage] = useState(1)
  const [pageSize, setPageSize] = useState(10)
  const [deleteModal, setDeleteModal] = useState(false)
  const [deleteId, setDeleteId] = useState(null)
  const [editLoading, setEditLoading] = useState(false)
  const [tableLoading, setTableLoading] = useState(false)
  const [viewModalVisible, setViewModalVisible] = useState(false)
  const [viewData, setViewData] = useState(null)

  const handleView = (record) => {
    setViewData(record)
    setViewModalVisible(true)
  }

  useEffect(() => {
    fetchChildren()
    fetchTableData()
  }, [])

  // ================= FETCH DATA =================

  const fetchChildren = async () => {
    try {
      const res = await axiosInstance.get(getChildrenList)
      setChildrenList(res.data)
    } catch (err) {
      toast.error('Failed to fetch children list')
    }
  }

  const fetchTableData = async () => {
    try {
      setTableLoading(true)
      const res = await axiosInstance.get(GetChildrenHomeVisitData)
      setTableData(res.data)
    } catch (err) {
      toast.error('Failed to fetch table data')
    } finally {
      setTableLoading(false)
    }
  }

  // ================= ADD =================

  const handleAdd = () => {
    form.resetFields()
    setIsEditMode(false)
    setEditingId(null)
    setShowForm(true)
  }

  // ================= EDIT =================

  // const handleEdit = (record) => {
  //   try {
  //     setEditLoading(true)
  //     setIsEditMode(true)
  //     setEditingId(record.reg_id)
  //     setShowForm(true)

  //     form.setFieldsValue({
  //       childId: record.reg_id,
  //       visitDate: record.date_of_visit ? dayjs(record.date_of_visit) : null,

  //       visitorName: record.name_of_visitor,
  //       visitorRole: record.visitor_relation,

  //       houseType: record.type_of_house,
  //       ownershipStatus: record.ownership_status,
  //       numRooms: record.number_of_rooms,

  //       waterFacility: record.water_facility,
  //       electricity: record.electricity,
  //       sanitation: record.sanitation_facility,

  //       membersMet: record.members_met_during_visit,
  //       childFamilyRelation: record.observation_on_child,

  //       homeCondition: record.general_condition_of_home,
  //       recommendations: record.recommendations,

  //       visitPhoto: record.home_visit_photo
  //         ? [
  //             {
  //               uid: '-1',
  //               name: 'Visit Photo',
  //               status: 'done',
  //               url: IMG_URL + record.home_visit_photo,
  //             },
  //           ]
  //         : [],
  //     })
  //   } catch (error) {
  //     console.error(error)
  //   } finally {
  //     setEditLoading(false)
  //   }
  // }

  const handleEdit = (record) => {
    try {
      setEditLoading(true)
      setIsEditMode(true)
      setEditingId(record.id)
      setShowForm(true)

      form.setFieldsValue({
        childId: record.reg_id,

        visitDate: record.date_of_visit ? dayjs(record.date_of_visit) : null,

        visitorName: record.name_of_visitor || '',
        visitorRole: record.visitor_relation || '',

        //  Convert to string
        houseType: record.type_of_house,
        ownershipStatus: record.ownership_status,
        numRooms: record.number_of_rooms || '',

        waterFacility: record.water_facility,
        electricity: record.electricity,
        sanitation: record.sanitation_facility,

        membersMet: record.members_met_during_visit || '',
        childFamilyRelation: record.observation_on_child || '',

        homeCondition: record.general_condition_of_home || '',
        recommendations: record.recommendations || '',

        //  FILE FIX (important)
        visitPhoto: record.home_visit_photo
          ? [
              {
                uid: '-1',
                name: record.home_visit_photo,
                status: 'done',
                url: IMG_URL + record.home_visit_photo,
              },
            ]
          : [],
      })
    } catch (error) {
      console.error(error)
    } finally {
      setEditLoading(false)
    }
  }

  // ================= DELETE =================
  const handleDelete = async () => {
    try {
      const res = await axiosInstance.delete(
        `${DeleteChildrenHomeVisitData}/${deleteId}`,
      )
      if (res.data === 'DELETED') {
        toast.success('Deleted successfully')
        setDeleteModal(false)
        fetchTableData()
      } else if (res.data === 'NOTFOUND') {
        toast.warn('Data not found!')
      }
    } catch (err) {
      toast.error('Delete failed')
    }
  }

  // ================= CANCEL =================

  const handleCancel = () => {
    form.resetFields()
    setIsEditMode(false)
    setEditingId(null)
    setShowForm(false)
  }

  // ================= SUBMIT / UPDATE =================

  const handleFinish = async (values) => {
    try {
      setLoading(true)

      const formData = new FormData()

      //  CORRECT FIELD MAPPING
      formData.append('reg_id', values.childId)
      formData.append(
        'date_of_visit',
        values.visitDate ? values.visitDate.format('YYYY-MM-DD') : '',
      )

      formData.append('name_of_visitor', values.visitorName)
      formData.append('visitor_relation', values.visitorRole || '')

      formData.append('type_of_house', values.houseType || '')
      formData.append('ownership_status', values.ownershipStatus || '')
      formData.append('number_of_rooms', values.numRooms || '')

      formData.append('water_facility', values.waterFacility ?? '')
      formData.append('electricity', values.electricity ?? '')
      formData.append('sanitation_facility', values.sanitation ?? '')

      formData.append('members_met_during_visit', values.membersMet || '')
      formData.append('observation_on_child', values.childFamilyRelation || '')

      formData.append('general_condition_of_home', values.homeCondition || '')
      formData.append('recommendations', values.recommendations || '')

      //  FILE
      if (values.visitPhoto && values.visitPhoto.length > 0) {
        const file = values.visitPhoto[0]

        if (file.originFileObj) {
          formData.append('home_visit_photo', file.originFileObj)
        } else if (file.url) {
          const existingPath = file.url.replace(IMG_URL, '')
          formData.append('home_visit_photo', existingPath)
        }
      }

      let response

      if (isEditMode) {
        response = await axiosInstance.put(
          `${updateChildrenHomeVisitData}/${editingId}`,
          formData,
        )

        if (response.data === 'UPDATED') {
          toast.success('Updated successfully')
          handleCancel()
          fetchTableData()
        }
      } else {
        response = await axiosInstance.post(saveChildrenHomeVisitData, formData)

        if (response.data === 'SAVED') {
          toast.success('Saved successfully')
          handleCancel()
          fetchTableData()
        } else if (response.data === 'ALREADY_EXIST') {
          toast.warn('Data already exist!')
        }
      }
    } catch (err) {
      console.error(err)
      toast.error('Failed to submit')
    } finally {
      setLoading(false)
    }
  }

  // ================= FILE VALIDATION =================

  const validateFile = (file) => {
    const allowedTypes = [
      'image/jpeg',
      'image/jpg',
      'image/png',
      'application/pdf',
    ]

    const isAllowedType = allowedTypes.includes(file.type)

    if (!isAllowedType) {
      toast.error('Only JPG, PNG, and PDF files are allowed!')
      return Upload.LIST_IGNORE
    }

    const isLt3M = file.size / 1024 / 1024 < 3

    if (!isLt3M) {
      toast.warn('File must be smaller than 3MB!')
      return Upload.LIST_IGNORE
    }

    return false // prevent auto upload
  }

  // ================= TABLE COLUMNS =================

  const columns = [
    {
      title: 'Sr No',
      render: (_, __, index) => (currentPage - 1) * pageSize + index + 1,
    },
    {
      title: 'Student Name',
      render: (_, record) =>
        record.student
          ? `${record.student.fname} ${record.student.mname} ${record.student.lname}`
          : '-',
    },
    {
      title: 'Visiting Date',
      dataIndex: 'date_of_visit',
    },
    {
      title: 'Visitor Name',
      dataIndex: 'name_of_visitor',
    },
    {
      title: 'Visitor Relation',
      dataIndex: 'visitor_relation',
    },

    ...(showActionColumn
      ? [
          {
            title: 'Action',
            render: (_, record) => (
              <Space>
                {pagePermission.is_view == 1 && (
                  <Button
                    title="View"
                    icon={<EyeOutlined />}
                    onClick={() => handleView(record)}
                  />
                )}
                {pagePermission.is_edit == 1 && (
                  <Button
                    title="Edit"
                    icon={<EditOutlined />}
                    onClick={() => handleEdit(record)}
                  />
                )}
                {pagePermission.is_delete == 1 && (
                  <Button
                    title="Delete"
                    danger
                    icon={<DeleteOutlined />}
                    onClick={() => {
                      setDeleteId(record.id)
                      setDeleteModal(true)
                    }}
                  />
                )}
              </Space>
            ),
          },
        ]
      : []),
  ]

  const HOUSE_TYPE = {
    1: 'Home1',
    2: 'Home2',
    3: 'Home3',
  }

  const OWNERSHIP = {
    1: 'Owned',
    2: 'Rented',
    3: 'Other',
  }

  const YES_NO = {
    1: 'Available',
    0: 'Not Available',
  }

  return (
    <>
      <AdminHeader />
      <div className="student-form-section container-fluid">
        <div className="student-form-wrapper p-4 pt-0">
          <div className="row student-form-title">
            <h3 className="section-title1 text-start mb-3">
              Children Home Visit
            </h3>
          </div>

          {/* ================= TABLE SECTION ================= */}

          {!showForm && (
            <>
              <Row justify="space-between" className="mb-3">
                <Col xs={24} md={10} lg={14}></Col>
                <Col
                  xs={24}
                  md={6}
                  lg={4}
                  className="text-end pb-2 px-md-2 pb-md-0"
                >
                  {pagePermission.is_new == 1 && (
                    <Button
                      type="primary"
                      icon={<PlusOutlined />}
                      onClick={handleAdd}
                    >
                      Add
                    </Button>
                  )}
                </Col>
                <Col xs={24} md={6} lg={6}>
                  <Input
                    placeholder="Search by name"
                    value={searchText}
                    onChange={(e) => setSearchText(e.target.value)}
                  />
                </Col>
              </Row>

              <Table
                dataSource={tableData.filter((item) => {
                  const search = searchText.toLowerCase()

                  return (
                    item.visitor_relation?.toLowerCase().includes(search) ||
                    item.name_of_visitor?.toLowerCase().includes(search)
                  )
                })}
                columns={columns}
                pagination={{
                  current: currentPage,
                  pageSize: pageSize,
                  onChange: (page, size) => {
                    setCurrentPage(page)
                    setPageSize(size)
                  },
                }}
                rowKey="id"
                bordered
                loading={tableLoading}
                className="shadow rounded custom-table p-0"
                style={{
                  overflowX: 'auto',
                  border: '1px solid #dfdfdf',
                  backgroundColor: 'white',
                }}
              />
            </>
          )}

          {/* ================= FORM SECTION ================= */}

          {showForm && (
            <Spin spinning={editLoading}>
              <div className="row student-form-container rounded shadow">
                <Form
                  form={form}
                  layout="vertical"
                  onFinish={handleFinish}
                  autoComplete="off"
                >
                  {/*  Select Child */}
                  <Row
                    gutter={16}
                    className="mt-3 p-2 border roundplaceed"
                    style={{ background: '#fafafa' }}
                  >
                    <Col xs={24} md={14} lg={12}>
                      <Form.Item
                        label="Select Children Name"
                        name="childId"
                        rules={[
                          { required: true, message: 'Please select a child' },
                        ]}
                      >
                        <Select
                          disabled={isEditMode}
                          showSearch
                          placeholder="Search by name / reg no"
                          optionFilterProp="children"
                          filterOption={(input, option) =>
                            option?.children
                              ?.toString()
                              .toLowerCase()
                              .includes(input.toLowerCase())
                          }
                        >
                          {childrenList.map((child) => (
                            <Option key={child.id} value={child.id}>
                              {child.fname} {child.mname} {child.lname} (Reg No:{' '}
                              {child.reg_no})
                            </Option>
                          ))}
                        </Select>
                      </Form.Item>
                    </Col>
                    <Col xs={24} md={8} lg={4}>
                      <Form.Item
                        label="Date of Visit"
                        name="visitDate"
                        rules={[
                          {
                            required: true,
                            message: 'Please select visit date',
                          },
                        ]}
                      >
                        <DatePicker
                          style={{ width: '100%' }}
                          format="DD-MM-YYYY"
                        />
                      </Form.Item>
                    </Col>
                  </Row>

                  {/* Visitors Information */}
                  <div className="divider-left-only">
                    <h5>Visitor Details -</h5>
                  </div>

                  <Row
                    gutter={16}
                    className="p-2 border rounded"
                    style={{ background: '#fafafa' }}
                  >
                    <Col xs={24} md={12}>
                      <Form.Item
                        label="Name of Visitor"
                        name="visitorName"
                        rules={[
                          { required: true, message: 'Enter visitor name' },
                        ]}
                      >
                        <Input placeholder="Enter visitor name" />
                      </Form.Item>
                    </Col>

                    <Col xs={24} md={12}>
                      <Form.Item
                        label="Designation / Role / Relation"
                        name="visitorRole"
                      >
                        <Input placeholder="Enter visitor's role/designation" />
                      </Form.Item>
                    </Col>
                  </Row>

                  {/*  Home Environment */}
                  <div className="divider-left-only">
                    <h5>Home Environment -</h5>
                  </div>

                  <Row
                    gutter={16}
                    className="p-2 border rounded"
                    style={{ background: '#fafafa' }}
                  >
                    <Col xs={24} md={12} lg={8}>
                      <Form.Item label="Type of House" name="houseType">
                        <Select placeholder="Select type of house">
                          {Object.entries(HOUSE_TYPE).map(([key, value]) => (
                            <Option key={key} value={Number(key)}>
                              {value}
                            </Option>
                          ))}
                        </Select>
                      </Form.Item>
                    </Col>

                    <Col xs={24} md={12} lg={8}>
                      <Form.Item
                        label="Ownership Status"
                        name="ownershipStatus"
                      >
                        <Select placeholder="Select ownership">
                          {Object.entries(OWNERSHIP).map(([key, value]) => (
                            <Option key={key} value={Number(key)}>
                              {value}
                            </Option>
                          ))}
                        </Select>
                      </Form.Item>
                    </Col>

                    <Col xs={24} md={12} lg={8}>
                      <Form.Item label="Number of Rooms" name="numRooms">
                        <Input
                          type="number"
                          placeholder="Enter number of rooms"
                        />
                      </Form.Item>
                    </Col>

                    <Col xs={24} md={12} lg={8}>
                      <Form.Item label="Water Facility" name="waterFacility">
                        <Radio.Group
                          className="border p-1 rounded"
                          style={{ backgroundColor: '#d4d4d4' }}
                        >
                          <Radio value={1}>Available</Radio>
                          <Radio value={0}>Not Available</Radio>
                        </Radio.Group>
                      </Form.Item>
                    </Col>

                    <Col xs={24} md={12} lg={8}>
                      <Form.Item label="Electricity" name="electricity">
                        <Radio.Group
                          className="border p-1 rounded"
                          style={{ backgroundColor: '#d4d4d4' }}
                        >
                          <Radio value={1}>Available</Radio>
                          <Radio value={0}>Not Available</Radio>
                        </Radio.Group>
                      </Form.Item>
                    </Col>

                    <Col xs={24} md={12} lg={8}>
                      <Form.Item label="Sanitation Facility" name="sanitation">
                        <Radio.Group
                          className="border p-1 rounded"
                          style={{ backgroundColor: '#d4d4d4' }}
                        >
                          <Radio value={1}>Available</Radio>
                          <Radio value={0}>Not Available</Radio>
                        </Radio.Group>
                      </Form.Item>
                    </Col>
                  </Row>

                  {/*  Family Interaction */}
                  <div className="divider-left-only">
                    <h5>Family Interaction -</h5>
                  </div>

                  <Row
                    gutter={16}
                    className="mt-3 p-2 border rounded"
                    style={{ background: '#fafafa' }}
                  >
                    <Col xs={24}>
                      <Form.Item
                        label="Members met during visit"
                        name="membersMet"
                      >
                        <TextArea
                          rows={2}
                          placeholder="List family members met during visit"
                        />
                      </Form.Item>
                    </Col>

                    <Col xs={24}>
                      <Form.Item
                        label="Observation on child’s relationship with family"
                        name="childFamilyRelation"
                      >
                        <TextArea
                          rows={3}
                          placeholder="Describe interaction between child and family"
                        />
                      </Form.Item>
                    </Col>
                  </Row>

                  {/*  Observations */}
                  <div className="divider-left-only">
                    <h5>Observations & Recommendations -</h5>
                  </div>

                  <Row
                    gutter={16}
                    className="p-2 border rounded"
                    style={{ background: '#fafafa' }}
                  >
                    <Col xs={24}>
                      <Form.Item
                        label="General Condition of Home"
                        name="homeCondition"
                      >
                        <TextArea
                          rows={3}
                          placeholder="Describe cleanliness, maintenance, etc."
                        />
                      </Form.Item>
                    </Col>
                    <Col xs={24}>
                      <Form.Item
                        label="Recommendations / Follow-up Actions"
                        name="recommendations"
                      >
                        <TextArea
                          rows={3}
                          placeholder="Enter any suggestions or required follow-up"
                        />
                      </Form.Item>
                    </Col>
                  </Row>

                  {/*  Upload Images */}
                  <div className="divider-left-only">
                    <h5>Upload Home Visit Photo -</h5>
                  </div>

                  <Row
                    gutter={16}
                    className="p-2 border rounded"
                    style={{ background: '#fafafa' }}
                  >
                    <Col xs={24} md={6}>
                      <Form.Item
                        label="Upload Photo"
                        name="visitPhoto"
                        valuePropName="fileList"
                        getValueFromEvent={(e) => e.fileList}
                      >
                        <Upload
                          beforeUpload={() => false}
                          listType="picture"
                          style={{ width: '100%' }}
                        >
                          <Button
                            icon={<UploadOutlined />}
                            style={{ width: '100%' }}
                          >
                            Upload Photo
                          </Button>
                        </Upload>
                      </Form.Item>
                    </Col>
                  </Row>

                  <Divider />

                  <Row justify="end" className="pb-5">
                    <Space>
                      <Button htmlType="reset" onClick={handleCancel}>
                        Cancel
                      </Button>
                      <Button type="primary" htmlType="submit">
                        {!isEditMode ? 'Submit' : 'Update'}
                      </Button>
                    </Space>
                  </Row>
                </Form>
              </div>
            </Spin>
          )}

          {/* ===== VIEW MODAL ===== */}
          <Modal
            title={
              <div style={{ fontSize: '18px', fontWeight: 600 }}>
                👁 View Children Home Visit
              </div>
            }
            open={viewModalVisible}
            onCancel={() => setViewModalVisible(false)}
            footer={[
              <Button
                key="close"
                type="primary"
                onClick={() => setViewModalVisible(false)}
              >
                Close
              </Button>,
            ]}
            width={900}
            style={{
              top: 20,
              paddingBottom: 50,
            }}
            centered
            bodyStyle={{
              maxHeight: '75vh',
              overflowY: 'auto',
              overflowX: 'hidden',
              paddingBottom: 10,
            }}
          >
            {viewData && (
              <div
                style={{
                  backgroundColor: '#f5f7fa',
                  padding: '20px 5px',
                  borderRadius: '8px',
                }}
              >
                {/* ===== STUDENT INFO ===== */}
                <Row className="mb-3">
                  <Col span={6}>
                    <strong>Student Name :</strong>
                  </Col>
                  <Col span={18}>
                    <div className="view-box">
                      {viewData?.student?.fname} {viewData?.student?.mname}{' '}
                      {viewData?.student?.lname}
                    </div>
                  </Col>
                </Row>

                <Row className="mb-3">
                  <Col span={6}>
                    <strong>Visit Date :</strong>
                  </Col>
                  <Col span={18}>
                    <div className="view-box">{viewData?.date_of_visit}</div>
                  </Col>
                </Row>

                <Divider />

                {/* ===== VISITOR ===== */}
                <Row className="mb-3">
                  <Col span={6}>
                    <strong>Visitor Name :</strong>
                  </Col>
                  <Col span={18}>
                    <div className="view-box">{viewData?.name_of_visitor}</div>
                  </Col>
                </Row>

                <Row className="mb-3">
                  <Col span={6}>
                    <strong>Visitor Relation :</strong>
                  </Col>
                  <Col span={18}>
                    <div className="view-box">{viewData?.visitor_relation}</div>
                  </Col>
                </Row>

                <Divider />

                {/* ===== HOME ENVIRONMENT ===== */}
                <Row className="mb-3">
                  <Col span={6}>
                    <strong>Type of House :</strong>
                  </Col>
                  <Col span={18}>
                    <div className="view-box">
                      {HOUSE_TYPE[viewData?.type_of_house] || '-'}
                    </div>
                  </Col>
                </Row>

                <Row className="mb-3">
                  <Col span={6}>
                    <strong>Ownership :</strong>
                  </Col>
                  <Col span={18}>
                    <div className="view-box">
                      {OWNERSHIP[viewData?.ownership_status] || '-'}
                    </div>
                  </Col>
                </Row>

                <Row className="mb-3">
                  <Col span={6}>
                    <strong>No. of Rooms :</strong>
                  </Col>
                  <Col span={18}>
                    <div className="view-box">{viewData?.number_of_rooms}</div>
                  </Col>
                </Row>

                <Row className="mb-3">
                  <Col span={6}>
                    <strong>Water :</strong>
                  </Col>
                  <Col span={18}>
                    <div className="view-box">
                      {YES_NO[viewData?.water_facility]}
                    </div>
                  </Col>
                </Row>

                <Row className="mb-3">
                  <Col span={6}>
                    <strong>Electricity :</strong>
                  </Col>
                  <Col span={18}>
                    <div className="view-box">
                      {YES_NO[viewData?.electricity]}
                    </div>
                  </Col>
                </Row>

                <Row className="mb-3">
                  <Col span={6}>
                    <strong>Sanitation :</strong>
                  </Col>
                  <Col span={18}>
                    <div className="view-box">
                      {YES_NO[viewData?.sanitation_facility]}
                    </div>
                  </Col>
                </Row>

                <Divider />

                {/* ===== FAMILY ===== */}
                <Row className="mb-3">
                  <Col span={6}>
                    <strong>Members Met :</strong>
                  </Col>
                  <Col span={18}>
                    <div className="view-box">
                      {viewData?.members_met_during_visit}
                    </div>
                  </Col>
                </Row>

                <Row className="mb-3">
                  <Col span={6}>
                    <strong>Child Relation :</strong>
                  </Col>
                  <Col span={18}>
                    <div className="view-box">
                      {viewData?.observation_on_child}
                    </div>
                  </Col>
                </Row>

                <Divider />

                {/* ===== OBSERVATION ===== */}
                <Row className="mb-3">
                  <Col span={6}>
                    <strong>Home Condition :</strong>
                  </Col>
                  <Col span={18}>
                    <div className="view-box">
                      {viewData?.general_condition_of_home}
                    </div>
                  </Col>
                </Row>

                <Row className="mb-3">
                  <Col span={6}>
                    <strong>Recommendations :</strong>
                  </Col>
                  <Col span={18}>
                    <div className="view-box">{viewData?.recommendations}</div>
                  </Col>
                </Row>

                <Divider />

                {/* ===== PHOTO ===== */}
                {viewData?.home_visit_photo && (
                  <Row className="mb-3">
                    <Col span={6}>
                      <strong>Visit Photo :</strong>
                    </Col>
                    <Col span={18}>
                      <div className="view-box">
                        <a
                          href={IMG_URL + viewData.home_visit_photo}
                          target="_blank"
                          rel="noreferrer"
                        >
                          View Photo
                        </a>
                      </div>
                    </Col>
                  </Row>
                )}
              </div>
            )}
          </Modal>

          {/* ===== DELETE MODAL ===== */}
          <Modal
            title="Confirm Delete"
            open={deleteModal}
            onOk={handleDelete}
            onCancel={() => setDeleteModal(false)}
          >
            Are you sure you want to delete this record?
          </Modal>
        </div>
      </div>
      <AdminFooter />
    </>
  )
}

export default ChildrenHomeVisitForm
